<template>
<div>
  <template v-if="!loading">
    <component :is="currentClientComponent" />
  </template>
  <v-dialog v-model="loading" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Loading client information...
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<style>
</style>

<script>
import apiService from '@/services/shared/agentPortalApiService.js';
import { mapActions, mapState } from 'vuex';
import ClientAccessRestricted from '@/views/clientViewer/Client/ClientAccessRestricted.vue';
import ClientViewTabs from '@/views/clientViewer/Client/ClientViewTabs.vue';
import ClientNotFound from '@/views/clientViewer/Client/ClientNotFound.vue';

export default {
  components: {
    ClientAccessRestricted,
    ClientNotFound,
    ClientViewTabs
  },
  data: function () {
    return {
      loading: true,
      restricted: false
    };
  },
  computed: {
    ...mapState(['client']),
    currentClientComponent: function () {
      if (this.restricted) return 'ClientAccessRestricted';
      if ((this.client || null) === null) return 'ClientNotFound';
      else return 'ClientViewTabs';
    },
    clientId: function () {
      return this.$route.params.clientId;
    }
  },
  created: async function () {
    await this.getClientInformation(this.clientId);
  },
  methods: {
    ...mapActions(['setClient', 'clearClient', 'setError']),
    getClientInformation: async function (clientId) {
      this.loading = true;

      this.clearClient();
      var res = await apiService.getClientInformation(clientId);

      switch (res.code) {
        case 0:
          this.restricted = false;
          this.setClient(res.data[0]);
          break;
        case 2:
          this.restricted = false;
          break;
        case 15:
          this.restricted = true;
          break;
        default:
          this.restricted = false;
          this.setError(res.message);
      }

      this.loading = false;
    }
  }
};
</script>
